import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { ErrorCode } from '../hosted-web-content-sdk.interface';
import { PermissionStatus, } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { createSdkError, formulateAppMessageResult, formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for handling permissions based calls.
 */
var PermissionsMessageHandler = /** @class */ (function (_super) {
    __extends(PermissionsMessageHandler, _super);
    function PermissionsMessageHandler(appSdkHost, permissionsService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.permissionsService = permissionsService;
        return _this;
    }
    PermissionsMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.permissions.requestUserConsentForPermission, function (_, permission) { return _this.handleRequestUserConsentAndStorePermissions(permission); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.permissions.requestUserConsentForPermission, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.permissions.storageService.getPermissionStatus, function (_, permission) {
            return formulateSdkResponse(permission, _this.permissionsService.storageService.getPermissionStatus, function (permissionStatus) { return permissionStatus == PermissionStatus.Consented; });
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.permissions.storageService.getPermissionStatus, error, scenario);
            },
        });
    };
    PermissionsMessageHandler.prototype.handleRequestUserConsentAndStorePermissions = function (requestedDevicePermission) {
        return __awaiter(this, void 0, void 0, function () {
            var previousPermissionsStatus, UserResponseToPermissionsRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.verifyPermisionsInManifest(requestedDevicePermission);
                        return [4 /*yield*/, this.checkPermissionsInStorage(requestedDevicePermission)];
                    case 1:
                        previousPermissionsStatus = _a.sent();
                        if (previousPermissionsStatus !== PermissionStatus.NeverAsked) {
                            return [2 /*return*/, formulateAppMessageResult([null, previousPermissionsStatus == PermissionStatus.Consented])];
                        }
                        return [4 /*yield*/, this.requestUserConsent(requestedDevicePermission)];
                    case 2:
                        UserResponseToPermissionsRequest = _a.sent();
                        return [4 /*yield*/, this.storePermissions(UserResponseToPermissionsRequest)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, formulateAppMessageResult([null, UserResponseToPermissionsRequest.status == PermissionStatus.Consented])];
                }
            });
        });
    };
    PermissionsMessageHandler.prototype.verifyPermisionsInManifest = function (requestedDevicePermission) {
        if (!this.appDefinition.devicePermissions.includes(requestedDevicePermission)) {
            throw createSdkError(ErrorCode.INTERNAL_ERROR, 'permission does not exist in the app manifest');
        }
    };
    PermissionsMessageHandler.prototype.checkPermissionsInStorage = function (requestedDevicePermission) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.permissionsService.storageService.getPermissionStatus(requestedDevicePermission)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PermissionsMessageHandler.prototype.requestUserConsent = function (requestedDevicePermission) {
        return __awaiter(this, void 0, void 0, function () {
            var UserResponseToPermissionsRequest, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.permissionsService.requestUserConsentForPermission(requestedDevicePermission)];
                    case 1:
                        UserResponseToPermissionsRequest = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        throw createSdkError(ErrorCode.INTERNAL_ERROR, 'An error ocured while requesting the user consent for permissions');
                    case 3: return [2 /*return*/, UserResponseToPermissionsRequest];
                }
            });
        });
    };
    PermissionsMessageHandler.prototype.storePermissions = function (UserResponseToPermissionsRequest) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.permissionsService.storageService.storePermissionConsent(UserResponseToPermissionsRequest)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PermissionsMessageHandler.prototype.validateDependencies = function () {
        if (!this.permissionsService) {
            throw 'No permissionsService provided';
        }
    };
    return PermissionsMessageHandler;
}(BaseMessageHandler));
export { PermissionsMessageHandler };
//# sourceMappingURL=permissions-message-handler.js.map